import React from "react";
import PropTypes from "prop-types";

import { Badge } from "shipnow-mercurio";

export const SameDayPickupBadge = (props) => {
  const { show } = props;

  if (show) {
    return <Badge color="highlight">Flex y Same Day</Badge>;
  }

  return null;
};

SameDayPickupBadge.propTypes = {
  show: PropTypes.bool,
};
